import PropTypes from "prop-types"
import styled, { keyframes, css } from "styled-components"

const Loading = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(p) =>
    p.overlay &&
    css`
      background-color: rgba(0, 0, 0, 0.6);
    `}
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const Ring = styled.div`
  display: inline-block;
  width: 64px;
  height: 64px;
  animation: ${rotate} 2s linear infinite;
  transform-origin: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: " ";
    display: block;
    width: 46px;
    height: 46px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid ${(p) => p.color};
    border-color: ${(p) => `${p.color} transparent ${p.color} transparent`};
    animation: lds-dual-ring 1.2s linear infinite;
  }
`

const RingLoader = ({ overlay, color }) => {
  return (
    <Loading overlay={overlay}>
      <Ring color={color} />
    </Loading>
  )
}

RingLoader.defaultProps = {
  overlay: true,
  color: "#fff",
}
RingLoader.propTypes = {
  overlay: PropTypes.bool,
  color: PropTypes.string,
}

export default RingLoader
